import {axiosReqGet, axiosReqOther} from "./config";
import { store } from '../store/store';

const USER_TOKEN = store.getState().authentication.user;

export const PropertyType = {
    getPropertyTypes
}

function getPropertyTypes(){
    const url = 'property-types/index.json';
    return axiosReqGet()
            .get(url)
            .then(res => {
            return res; 
        })
        .catch(err => { 
            alert(err.response.data.message)      
            return err; 
        })
}

export default PropertyType;